import React from "react";
import { Box, Avatar, Typography, useTheme, useMediaQuery } from "@mui/material";

const WorkflowSectionHeader = ({ trigger, count, icon }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMd = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      bgcolor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100], 
      borderRadius: { xs: 1, sm: 1.5, md: 1.75, lg: 2, xl: 2 }, 
      px: { xs: 0.75, sm: 1, md: 1.5, lg: 2, xl: 2 }, 
      py: { xs: 0.375, sm: 0.5, md: 0.75, lg: 1, xl: 1 }, 
      mb: { xs: 0.5, sm: 0.75, md: 0.75, lg: 1, xl: 1 }, 
      mt: { xs: 1.5, sm: 2, md: 2.5, lg: 3, xl: 3 } 
    }}>
      <Avatar sx={{ 
        bgcolor: theme.palette.primary.light, 
        mr: { xs: 0.75, sm: 1, md: 1.5, lg: 2, xl: 2 }, 
        width: { xs: 20, sm: 24, md: 30, lg: 32, xl: 32 }, 
        height: { xs: 20, sm: 24, md: 30, lg: 32, xl: 32 },
        fontSize: { xs: '0.625rem', sm: '0.75rem', md: '0.9375rem', lg: '1rem', xl: '1rem' }
      }}>
        {icon}
      </Avatar>
      <Typography 
        variant={isXs || isSm ? 'body2' : isMd ? 'subtitle2' : 'subtitle1'}
        fontWeight="bold" 
        color="text.primary"
        sx={{ 
          fontSize: { xs: '0.65rem', sm: '0.7rem', md: '0.875rem', lg: '0.9375rem', xl: '1rem' }
        }}
      >
        {trigger} <span style={{ 
          color: theme.palette.text.secondary, 
          fontWeight: 400,
          fontSize: isXs ? '0.6rem' : isSm ? '0.65rem' : isMd ? '0.75rem' : '0.875rem'
        }}>
          ({count})
        </span>
      </Typography>
    </Box>
  );
};

export default WorkflowSectionHeader; 